import { NgModule } from "@angular/core"
import { filtroProductos } from './filtroProductos';
import { valorTotalVenta } from './valorTotalVenta'
import { OrderByPipe } from './order-by/order-by';
import { TagInputModule } from 'ng2-tag-input';
import { AbcPipe } from './abc/abc';
import { PipesFiltroPipe } from './pipes-filtro/pipes-filtro';
import { FiltroPipe } from './filtro.pipe';
import { filtroProductosReserva } from "./filtroProductosReserva";
import { CountProductsPipe } from "./pipes-count-product/pipes-count-product";
import { PipesFiltroTallasPipe } from "./pipes-filtro-tallas/pipes-filtro-tallas";
import { PipesFiltroColorPipe } from "./pipes-filtro-color/pipes-filtro-color";
import { FiltroinventarioPipe } from "./filtroinventario.pipe";


@NgModule({
  declarations: [
    filtroProductos,
    valorTotalVenta,
    OrderByPipe,
    AbcPipe,
    PipesFiltroPipe,
    FiltroPipe,
    filtroProductosReserva,
    CountProductsPipe,
    PipesFiltroTallasPipe,
    PipesFiltroColorPipe,
    FiltroinventarioPipe
  ],
  exports: [
    filtroProductos,
    valorTotalVenta,
    OrderByPipe,
    AbcPipe,
    PipesFiltroPipe,
    FiltroPipe,
    filtroProductosReserva,
    CountProductsPipe,
    PipesFiltroTallasPipe,
    PipesFiltroColorPipe,
    FiltroinventarioPipe
  ],
  imports: [
    TagInputModule
  ]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts